import { useContext, useEffect, useRef } from 'react';
import { AppContext } from '../../contexts/context';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import UpdateIcon from '@mui/icons-material/Update';

export const AppUpdateCard = (props) => {
  const [ state ] = useContext(AppContext);

  const handleUpdateClick = () => {
    const registrationWaiting = state.appSwRegistration.waiting;
    if (registrationWaiting) {
      registrationWaiting.postMessage({ type: 'SKIP_WAITING' });
      registrationWaiting.addEventListener('statechange', e => {
        if (e.target.state === 'activated') {
          window.location.reload();
        }
      });
    }
  };

  var appVersion = useRef('...')

  const getNewVersion = () => {
    fetch('./version.json')
        .then((response) => response.json())
        .then((json) => {
          appVersion.current = json.version
        });
  }

  useEffect(() => {
    getNewVersion();
  }, []);

  return (
    <Card sx={{
        border: '1px solid',
        borderColor: '#d57c00',
        borderRadius: 5,
        display: "flex",
        flexDirection: "column",
        paddingX: 2,
        boxShadow: "none",
        alignItems: "left",
        justifyContent: "left"
      }}>
      <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: "#fff", padding:0.9 }} aria-label="status_icon">
              <UpdateIcon color={"primary"} sx={{fontSize:50, color: '#d57c00'}}/>
            </Avatar>
          }
          title="Update available"
          subheader="Reload this app"
          titleTypographyProps={{marginLeft:0, color:"text.primary", variant:"h6", fontWeight: 'normal'}}
      />
      <CardContent sx={{mt:0, pt:0, pb:0}}>
        <Typography variant="body2" color="text.secondary">
          A new version of the app is available: {appVersion.current}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          color="primary"
          sx={{color: '#d57c00'}}
          onClick={handleUpdateClick}
        >
          Update
        </Button>
      </CardActions>
    </Card>
  )
}

export default AppUpdateCard;
